import styled from 'styled-components';

export const Field = styled.div`
  position: relative;
  border-radius: 4px;
  background: #2b2d33;
  padding: 8px 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
`;

export const LeftSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const RightSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
`;

export const Input = styled.input<{ disabled?: boolean }>`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: ${({ disabled }) => (disabled ? '#a9aaad' : '#FFFFFF')};
  font-size: 16px;
  font-weight: 600;
  font-family: 'JetBrains Mono', monospace;

  &::placeholder {
    color: #a9aaad;
    font-weight: 600;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const Suffix = styled.span`
  color: #a9aaad;
  font-family: 'JetBrains Mono', monospace;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.24px;
  pointer-events: none;
  user-select: none;
`;

export const SearchButton = styled.button<{ disabled?: boolean }>`
  width: 45px;
  height: 40px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #30313b;
  border: 2px solid ${({ disabled }) => (disabled ? '#41424E' : '#fb6f6a')};
  color: ${({ disabled }) => (disabled ? '#41424E' : '#fb6f6a')};
  transition:
    transform 120ms ease,
    background 120ms ease;

  &:hover:not(:disabled) {
    background: rgba(255, 106, 94, 0.08);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:focus-visible:not(:disabled) {
    outline: none;
    box-shadow: 0 0 0 3px rgba(255, 106, 94, 0.25);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const MagnifierIcon = styled.svg`
  width: 18px;
  height: 18px;
`;
